import React, { useContext } from 'react'
import { AppContext } from "../../context/AppContext";
import Swal from 'sweetalert2';
import './WhiteLabel.styles.css'
import { toast } from 'react-toastify';

const WhiteLabel = () => {
	const { packageAccess, base_url, isWlFileDownloadReady } = useContext(AppContext);
	const downloadZip = () => {
		if (packageAccess.includes('whitelabel')) {

			const zipUrl = base_url + 'whitelabel/aibookFlow_y7531.zip';
			const link = document.createElement('a');
			link.href = zipUrl;
			link.download = 'aibookFlow.zip';
			link.click();
			toast.success("Your download will start shortly!");
			// Swal.fire({
			// 	title: "Download Successful!",
			// 	text: "Your download will start shortly!",
			// 	icon: "success"
			// });
		} else {
			toast.warning("You do not have permission to download the Whitelabel code.");
			// Swal.fire({
			// 	title: "Permission Denied",
			// 	text: "You do not have permission to download the Whitelabel code.",
			// 	icon: "warning"
			// });
		}
	};
	return (
		<div className="right-container">
			<div className="content">
				<div className="container-fluid">
					{/* start page title  */}
					<div className="row mb-2">
						<div className="col-12 ">
							<div className="page-title-box w-100">
								<h4 className="page-title">Whitelabel</h4>
							</div>
						</div>
					</div>
					{/* end page title  */}
					{/* Card  */}
					<div className="row">
						<div className="col-md-12">
							<div className="card w-100">
								<div className="head-part mb-0">
									<h6 className="profile-heading">Whitelabel</h6>
								</div>
								<div className="card-body">
									{/* Content */}
									<h4 className="description-text">
										{!isWlFileDownloadReady ? (
											<p>
												<span className="fw-bold">Exciting News! </span>
												To get access to the BookFlow AI Whitelabel program, please submit a ticket on our support desk with the code
												<span className="fw-bold"> "20ACTIVEWHITEBOOKFLOW25" </span>.
												We will provide you with whitelabel access once our launch week ends. Thank you for partnering with us!
											</p>
										) : (
											<div className="row mt-4">
												<div className="col-lg-12 text-center">
													<button id="downloadBtn" className="btn btn-primary" onClick={downloadZip}>
														Download Whitelabel Code
													</button>
												</div>
											</div>
										)}


									</h4>

									{/* End Content */}
								</div>
							</div>
						</div>
					</div>
					{/* End Card */}
				</div>
			</div>
		</div>
	)
}

export default WhiteLabel
